import { useAuthContext } from '@/contexts/AuthContext';

export function useAuth() {
  const { dbUser, loading, isAuthenticated, firebaseUser, refreshUser } = useAuthContext();
  
  return {
    user: dbUser,
    isLoading: loading,
    isAuthenticated,
    firebaseUser,
    refreshUser,
  };
}
